import StepTitle from './StepTitle'

export default StepTitle
